/*
@license
  Expanse by Archetype Themes (https://archetypethemes.co)
  Access unminified JS in assets/theme.js
*/

if (console && console.log) {
  console.log(
    "Expanse theme (" +
      theme.settings.themeVersion +
      ") by ARCHΞTYPE | Learn more at https://archetypethemes.co"
  );
}

(function () {
  "use strict";

  if (
    window.Shopify &&
    window.Shopify.theme &&
    navigator &&
    navigator.sendBeacon &&
    window.Shopify.designMode
  ) {
    navigator.sendBeacon(
      "https://api.archetypethemes.co/api/beacon",
      new URLSearchParams({
        shop: window.Shopify.shop,
        themeName:
          window.theme &&
          window.theme.settings &&
          `${window.theme.settings.themeName} v${window.theme.settings.themeVersion}`,
        role: window.Shopify.theme.role,
        route: window.location.pathname,
        themeId: window.Shopify.theme.id,
        themeStoreId: window.Shopify.theme.theme_store_id || 0,
        isThemeEditor: !!window.Shopify.designMode,
      })
    );
  }

  function DOMready(callback) {
    if (document.readyState != "loading") callback();
    else document.addEventListener("DOMContentLoaded", callback);
  }

  DOMready(function () {
    document.dispatchEvent(new CustomEvent("page:loaded"));
    syncQuantitySelectors(document);
  });
})();

function syncQuantitySelectors(root = document) {
  const quantitySelectors = root.querySelectorAll('quantity-selector');

  quantitySelectors.forEach((quantitySelector) => {
    const input = quantitySelector.querySelector('.element-quantity-selector__input');
    if (!input) return;

    const ruleSource = input.closest(
      '[data-quantity-min], [data-quantity-step], [data-quantity-max], quantity-selector, product-form'
    );

    const min = parseInt(
      input.getAttribute('min') ||
        input.dataset.min ||
        ruleSource?.dataset.min ||
        ruleSource?.dataset.quantityMin ||
        1,
      10
    );

    const step = parseInt(
      input.getAttribute('step') ||
        input.dataset.step ||
        ruleSource?.dataset.step ||
        ruleSource?.dataset.quantityStep ||
        1,
      10
    );

    const maxRaw =
      input.getAttribute('max') ||
      input.dataset.max ||
      ruleSource?.dataset.max ||
      ruleSource?.dataset.quantityMax;

    const max = maxRaw ? parseInt(maxRaw, 10) : null;

    let quantity = parseInt(input.value || min, 10);

    if (!Number.isFinite(quantity) || quantity < min) {
      quantity = min;
    }

    if (max !== null && quantity > max) {
      quantity = max;
    }

    if (step > 1 && quantity > min) {
      const offset = quantity - min;
      const remainder = offset % step;

      if (remainder !== 0) {
        quantity = quantity - remainder;
      }
    }

    input.setAttribute('min', String(min));
    input.setAttribute('step', String(step));
    input.dataset.min = String(min);
    input.dataset.step = String(step);

    if (max !== null) {
      input.setAttribute('max', String(max));
      input.dataset.max = String(max);
    } else {
      input.removeAttribute('max');
      delete input.dataset.max;
    }

    input.value = quantity;
    input.setAttribute('value', String(quantity));
    input.dataset.initialValue = String(quantity);

    quantitySelector.dataset.min = String(min);
    quantitySelector.dataset.step = String(step);

    if (max !== null) {
      quantitySelector.dataset.max = String(max);
    } else {
      delete quantitySelector.dataset.max;
    }

    quantitySelector.style.setProperty('--digit-count', `${quantity.toString().length}ch`);
  });
}

document.addEventListener('click', async function (event) {
  const button = event.target.closest('.load-more-button');
  if (!button) return;

  event.preventDefault();

  const nextUrl = button.dataset.nextUrl;
  const currentGrid = document.querySelector('.collection-grid.product-grid');
  const paginationWrapper = button.closest('.element-pagination');

  if (!nextUrl || !currentGrid || !paginationWrapper) return;

  button.disabled = true;
  button.textContent = 'Loading...';

  try {
    const response = await fetch(nextUrl);
    const html = await response.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');

    const nextGrid = doc.querySelector('.collection-grid.product-grid');
    const nextButton = doc.querySelector('.load-more-button');

    if (!nextGrid) {
      paginationWrapper.remove();
      return;
    }

    const nextPagination = nextGrid.querySelector('.element-pagination');
    if (nextPagination) {
      nextPagination.remove();
    }

    Array.from(nextGrid.children).forEach((child) => {
      currentGrid.insertBefore(child, paginationWrapper);
    });

    syncQuantitySelectors(currentGrid);

    document.dispatchEvent(
      new CustomEvent('collection:products:loaded', {
        bubbles: true,
        detail: {
          grid: currentGrid
        }
      })
    );

    if (nextButton?.dataset.nextUrl) {
      button.dataset.nextUrl = nextButton.dataset.nextUrl;
      button.disabled = false;
      button.textContent = 'Load more';
    } else {
      paginationWrapper.remove();
    }
  } catch (error) {
    console.error('Load more failed:', error);
    button.disabled = false;
    button.textContent = 'Load more';
  }
});